import { post } from './http.js'

// 文件上传与 OCR 识别
export const uploadSingleFileAndIDOCR = (params) => post('/unicom/cluster/file/uploadSingleFileAndIDOCR', params)
export const uploadSingleFileAndBankOCR = (params) => post('/unicom/cluster/file/uploadSingleFileAndBankOCR', params)
export const uploadSingleFile = (params) => post('/unicom/cluster/file/uploadSingleFile', params)
export const uploadMarketImg = (params) => post('/unicom/cluster/file/uploadMarketImg', params)
